import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	otpSendedDate: null,
	autoIbanOtpSendedDate: null,
	isUserSeenNewUpdate: false,
	productIdSelected: null,
};

export const applicationSlice = createSlice({
	name: "application",
	initialState,
	reducers: {
		setOtpSendedDate(state, action) {
			return {
				...state,
				otpSendedDate: action.payload,
			};
		},
		setUserSeenNewUpdate(state, action) {
			state.isUserSeenNewUpdate = true;
		},
		setAutoIbanOtpSendedDate(state, action) {
			return {
				...state,
				autoIbanOtpSendedDate: action.payload,
			};
		},
		setProductIdSelected(state, action) {
			state.productIdSelected = action.payload;
		},
	},
});

export const { setOtpSendedDate, setUserSeenNewUpdate, setAutoIbanOtpSendedDate, setProductIdSelected } =
	applicationSlice.actions;

export default applicationSlice.reducer;
